
export const DOWNVOTED_COMMENT_ALERT = "downvotedCommentAlert";

export const COMMENT_MODERATOR_ACTION_TYPES = {
  [DOWNVOTED_COMMENT_ALERT]: "Downvoted Comment",
};
